<button class="mc-ar__button"
		[class]="{'modal': !isProd}"
		(click)="openAR()"
		[disabled]="isProd && !isModelLoaded">
	{{ 'augmented_reality.ar' | translate }}
</button>